// src/components/Grid/DataTabs.tsx
import React, { useState } from 'react';
import { GeographicMetadata } from '../../types/geographic';

interface DataTabsProps {
  histogram: string;
  stats: {
    num_points: number;
    z_min: number;
    z_max: number;
    z_mean: number;
    z_std: number;
  };
  geoMetadata: GeographicMetadata;
}

const DataTabs: React.FC<DataTabsProps> = ({ histogram, stats, geoMetadata }) => {
  const [activeTab, setActiveTab] = useState<string | null>(null);

  const toggleTab = (tabName: string) => {
    if (activeTab === tabName) {
      setActiveTab(null);  // Collapse if already open
    } else {
      setActiveTab(tabName);  // Open the clicked tab
    }
  };

 return (
  <div className="data-tabs">
    <div className="tab-buttons">
      <button 
        className={`tab-button ${activeTab === 'stats' ? 'active' : ''}`}
        onClick={() => toggleTab('stats')}
      >
        Statistics ▼
      </button>
      <button 
        className={`tab-button ${activeTab === 'histogram' ? 'active' : ''}`}
        onClick={() => toggleTab('histogram')}
      >
        Distribution ▼
      </button>
      <button 
        className={`tab-button ${activeTab === 'geographic' ? 'active' : ''}`}
        onClick={() => toggleTab('geographic')}
      >
        Geographic Info ▼
      </button>
    </div>
    
    <div className={`tab-content stats-tab ${activeTab === 'stats' ? 'active' : ''}`}>
      {stats && (
        <table>
          <tbody>
            {Object.entries(stats).map(([key, value]) => (
              <tr key={key}>
                <th>{key.split('_').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}</th>
                <td>{typeof value === 'number' ? value.toFixed(2) : value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>

    <div className={`tab-content histogram-tab ${activeTab === 'histogram' ? 'active' : ''}`}>
      {histogram && (
        <img 
          src={`data:image/png;base64,${histogram}`}
          alt="Value distribution"
          className="histogram-image"
        />
      )}
    </div>

    <div className={`tab-content geographic-tab ${activeTab === 'geographic' ? 'active' : ''}`}>
      {geoMetadata && (
        <table>
          <tbody>
            <tr>
              <th>Coordinate System</th>
              <td>{geoMetadata.original_crs}</td>
            </tr>
            {geoMetadata.utm_zone && (
              <tr>
                <th>UTM Zone</th>
                <td>{geoMetadata.utm_zone}{geoMetadata.utm_hemisphere}</td>
              </tr>
            )}
            <tr>
              <th>Bounds</th>
              <td>
                X: {geoMetadata.bounds_utm.x_min.toFixed(2)} to {geoMetadata.bounds_utm.x_max.toFixed(2)}<br/>
                Y: {geoMetadata.bounds_utm.y_min.toFixed(2)} to {geoMetadata.bounds_utm.y_max.toFixed(2)}
              </td>
            </tr>
            <tr>
              <th>Scale Factor</th>
              <td>{geoMetadata.scale_factor.toFixed(6)}</td>
            </tr>
            <tr>
              <th>Aspect Ratio</th>
              <td>{geoMetadata.aspect_ratio.toFixed(3)}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  </div>
);
};

export default DataTabs;